import { createContext } from 'react';
import { observable, makeObservable, action } from 'mobx';

export class GeneralStore {
  constructor() {
    this.contactInfo = null;
    this.openPrivacyPolicy = false;
    this.footerLinks = null;
    makeObservable(this, {
      contactInfo: observable,
      footerLinks: observable,
      setContactInfo: action,
      setFooterLinks: action,
      openPrivacyPolicy: observable,
      setOpenPrivacyPolicy: action,
    });
  }

  setOpenPrivacyPolicy(openPrivacyPolicy) {
    this.openPrivacyPolicy = openPrivacyPolicy;
  }

  setContactInfo(contactInfo) {
    this.contactInfo = contactInfo;
  }

  setFooterLinks(footerLinks) {
    this.footerLinks = footerLinks;
  }
}

export const GeneralContext = createContext();
